// NOTE: doesn't include Edge (which is IE 12)
const IE_USER_AGENTS = ['MSIE ', 'Trident/'];

class UserAgentHelper {
  static isIE11OrBelow() {
    const { navigator: { userAgent } } = window;
    return IE_USER_AGENTS.reduce(
      (acc, userAgentID) => acc || (userAgent.search(userAgentID) >= 0),
      false,
    );
  }

  static isIphone() {
    const { navigator: { userAgent } } = window;
    return /iPhone/i.test(userAgent);
  }
}

export { UserAgentHelper };



// WEBPACK FOOTER //
// ./src/helpers/UserAgentHelper.js